export default {
    UPDATE_STATUS: (merchantId, operatorId) => `merchants/${merchantId}/savings-operator/${operatorId}/status-update/`,
    OPERATORS: ({ merchantId, savingsId }) => `merchants/${merchantId}/savings-accounts/${savingsId}/`,
    OPERATOR_TYPES: `merchants/operator-types/`,
    CUSTOMERS: ({ merchantId, savingsId }) => `merchants/${merchantId}/customers/${savingsId}/`
}